export const COLORS = {
    COPPER: '#B87333',
    PLUM: '#5E405B',
    SAGE_GREEN: '#A8BBA2',
    WARM_CONCRETE: '#f5f5f5',
    ERROR: "#dc3545"
}; 